import * as React from 'react';
export var IconChevronDown = React.forwardRef(function IconChevronDown({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M4.198 6.241a.75.75 0 0 1 1.06-.042L8 8.729l2.742-2.53A.75.75 0 1 1 11.759 7.3l-3.25 3a.75.75 0 0 1-1.017 0l-3.251-3a.75.75 0 0 1-.043-1.06Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M6.184 10.265a.75.75 0 0 1 1.057-.081l4.76 4.081 4.761-4.085a.75.75 0 1 1 .977 1.139l-5.25 4.503a.75.75 0 0 1-.976 0l-5.248-4.5a.75.75 0 0 1-.081-1.057Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M6.184 10.265a.75.75 0 0 1 1.057-.081l4.76 4.081 4.761-4.085a.75.75 0 1 1 .977 1.139l-5.25 4.503a.75.75 0 0 1-.976 0l-5.248-4.5a.75.75 0 0 1-.081-1.057Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
